import * as React from 'react';
import {CSSProperties} from 'react';
import styled from '@emotion/styled';

export const TableFooter = styled.div`
}
@media only screen and (max-width: 1024px) {
    tfoot {
        tr {
            border: 0;
            border-bottom: 5px solid #e5e5e5;
            background-color: #f5f5f5;
            padding: 1rem;
            float: none;
        }

        td {
            border: 0 !important;
            display: table;
            padding: 0 0 0 45% !important;
            line-height: 2 !important;
            position: relative;
            width: 100%;

            &:first-of-type::after {
                visibility: hidden;
            }

            &:empty {
                display: none;
            }
        }
    }
`;

interface TableCardsProps {
    columns: {
        customFormatter?: (originalObject: unknown, rowIndex?: number) => string | React.JSX.Element;
        fieldName?: string;
        hidden?: boolean;
        maskPII?: boolean;
        hideTitleSmView?: boolean;
        overrideTH?: (key: number, className: string) => React.JSX.Element;
        rightAlign?: boolean;
        style?: CSSProperties;
        title: string;
    }[];
    customFooter?: React.JSX.Element;
    customRowsAfter?: React.JSX.Element;
    data: unknown[];
    e2e?: string;
    disableLabels?: boolean;
    compactPadding?: boolean;
    printClasses?: boolean;
}

export const TableCards = ({
    columns,
    customFooter,
    customRowsAfter,
    data,
    e2e,
    disableLabels,
    compactPadding = false,
    printClasses = false,
}: TableCardsProps) => {
    return (
        <>
            <div className="tw-block lg:tw-hidden">
                <table
                    className={`tw-table-auto tw-w-full sm:tw-min-w-[375px] tw-mb-4${
                        printClasses ? ' print:tw-w-full print:tw-border-spacing-0 tw-mb-2.5' : ''
                    }`}
                    data-e2e={`${e2e}_mobile`}
                    style={{emptyCells: 'hide'}}
                >
                    <tbody>
                        {data?.map((row, rowIndex) => (
                            <tr
                                className="tw-bg-white tw-border-solid tw-border tw-rounded-[3px] tw-mb-4 tw-float-left tw-p-5 tw-w-full tw-block"
                                key={rowIndex}
                            >
                                {columns.map((column, colIndex) =>
                                    column.hidden ? (
                                        ``
                                    ) : (
                                        <td
                                            className={`tw-border-none tw-table tw-py-0 tw-pr-0 tw-pl-[45%] tw-leading-8 tw-relative tw-w-full${
                                                column.title
                                                    ? ` before:tw-content-[attr(data-title)] before:tw-font-bold before:tw-h-full before:tw-left-0 [&_data-title]:before:tw-m-auto before:tw-align-middle before:tw-whitespace-nowrap before:tw-w-[45%] ${
                                                          column.hideTitleSmView
                                                              ? 'before:tw-hidden before:lg:tw-table-cell'
                                                              : 'before:tw-table-cell'
                                                      }`
                                                    : ''
                                            } ${column.maskPII ? ' maskPII' : ''}${
                                                printClasses ? ' print:tw-border print:tw-border-black print:tw-p-2' : ''
                                            }`}
                                            data-title={disableLabels ? undefined : column.title ? `${column.title}:` : undefined}
                                            key={colIndex}
                                            style={compactPadding ? {paddingTop: 2, paddingBottom: 2} : {paddingTop: 8, paddingBottom: 8}}
                                        >
                                            {column.customFormatter ? column.customFormatter(row, rowIndex) : row[column.fieldName]}
                                        </td>
                                    ),
                                )}
                            </tr>
                        ))}
                        {customRowsAfter}
                    </tbody>
                    {!!customFooter && <TableFooter className="tfoot">{customFooter}</TableFooter>}
                </table>
            </div>
            <div className="tw-hidden lg:tw-block">
                <table
                    className={`tw-table-auto tw-w-full sm:tw-min-w-[375px] tw-mb-4${
                        printClasses ? ' print:tw-w-full print:tw-border-spacing-0 tw-mb-2.5' : ''
                    }`}
                    data-e2e={`${e2e}_desktop`}
                    style={{emptyCells: 'hide'}}
                >
                    <thead>
                        <tr className={`tw-bg-white tw-border-t tw-border-b`}>
                            {columns.map((column, index) =>
                                column.hidden ? (
                                    ``
                                ) : column.overrideTH ? (
                                    column.overrideTH(
                                        index,
                                        `tw-text-sm tw-whitespace-nowrap tw-font-normal tw-pl-3 tw-min-h-[61px] tw-pr-6 tw-py-3.5${
                                            column.rightAlign ? ' tw-text-right' : ''
                                        }${printClasses ? ' print:tw-border print:tw-border-black print:tw-p-2' : ''}
                                    }`,
                                    )
                                ) : (
                                    <td
                                        className={`tw-text-sm tw-whitespace-nowrap tw-font-normal tw-pl-3 tw-min-h-[61px] tw-pr-6 tw-py-3.5${
                                            column.rightAlign ? ' tw-text-right' : ''
                                        }${printClasses ? ' print:tw-border print:tw-border-black print:tw-p-2' : ''}`}
                                        key={index}
                                        style={column.style}
                                    >
                                        {column.title}
                                    </td>
                                ),
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((row, rowIndex) => (
                            <tr
                                className="tw-bg-white tw-border-x-0 tw-border-y"
                                key={rowIndex}
                            >
                                {columns.map((column, colIndex) =>
                                    column.hidden ? (
                                        ``
                                    ) : (
                                        <td
                                            className={`tw-pl-3 tw-pr-6 tw-my-3.5${column.rightAlign ? ' tw-text-right' : ''}${
                                                column.maskPII ? ' maskPII' : ''
                                            }${printClasses ? ' print:tw-border print:tw-border-black print:tw-p-2' : ''}`}
                                            data-title={disableLabels ? undefined : column.title ? `${column.title}:` : undefined}
                                            key={colIndex}
                                            style={compactPadding ? {paddingTop: 2, paddingBottom: 2} : {paddingTop: 8, paddingBottom: 8}}
                                        >
                                            {column.customFormatter ? column.customFormatter(row, rowIndex) : row[column.fieldName]}
                                        </td>
                                    ),
                                )}
                            </tr>
                        ))}
                        {customRowsAfter}
                    </tbody>
                    {!!customFooter && <TableFooter className="tfoot">{customFooter}</TableFooter>}
                </table>
            </div>
        </>
    );
};
